<template>
  <div>
    <Sticky>
      <nav
        class="navbar navbar-horizontal navbar-expand-lg py-0"
        style="background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%); border: none;"
      >
        <div class="container-fluid navbar-bar-outer">
          <div class="navbar-bar-row d-flex flex-nowrap align-items-center w-100">
            <div
              class="navbar-brand text-dark flex-shrink-0"
              :class="$route.path !== '/home' ? 'd-flex justify-content-between' : ''
                "
            >
              <img
                src="https://storage.googleapis.com/spacetech2/kob/kob_logo.avif"
                alt="KOB"
                @click="$router.push('/home')"
              />
            </div>
            <div class="d-flex flex-nowrap align-items-center navbar-bar-actions flex-grow-1 justify-content-end">
              <div
                class="d-flex flex-nowrap align-items-center"
                v-if="$route.path !== '/auth/login' && authUser"
              >

                <span
                  class="my-auto pr-3"
                  style="border-right: 1px solid gray;"
                >
                  <span
                    class="text-sm text-uppercase"
                    style="color: #B7AAAA"
                  >
                    <img
                      loading="lazy"
                      class="coin"
                      src="https://storage.googleapis.com/spacetech2/phoenix888/coin.png"
                      alt=""
                    >
                  </span>
                  <span class="text-dark text-md">
                    <b>{{ Number($store.state.authUser.amount).toLocaleString() }}</b> MMK
                  </span>
                </span>
              </div>

              <div
                class="mr-3 pt-2"
                @click="appInstall()"
                v-if="!authUser && isAndroid && !isInAppWebView"
              >
                <img
                  class="ml-2 my-auto mx-auto"
                  style="width: 1.5rem;"
                  src="https://storage.googleapis.com/spacetech2/shwemyanmar/download.png"
                  alt=""
                >
              </div>

              <div
                v-if="!$store.state.authUser.name"
                class="d-flex flex-nowrap align-items-center flex-shrink-0"
              >
                <button
                  v-if="showQuickLogin"
                  type="button"
                  class="btn my-4 text-nowrap mr-2"
                  style="background: linear-gradient(135deg, #fde047 0%, #facc15 45%, #eab308 100%); color: #0c0a09; border-radius: 20px; min-width: 5.5rem; padding-left: 0.65rem; padding-right: 0.65rem; box-shadow: none; font-weight: 600;"
                  @click="quickLogin"
                >
                  <span v-if="!isQuickLogin">
                    <i class="fas fa-bolt mr-1"></i>{{ $t('auth.quick_login') }}
                  </span>
                  <Loading
                    v-else
                    color="#0c0a09"
                    size="20"
                    class="px-2 py-0"
                  />
                </button>

                <button
                  @click="$router.push('/auth/login')"
                  type="button"
                  class="btn my-4 text-nowrap"
                  style="background-image: linear-gradient(135deg, #b45309 0%, #eab308 50%, #fcd34d 100%); color: #0c0a09; border-radius: 20px; width: 6.5rem; box-shadow: none; font-weight: 600;"
                >
                  <div>
                    {{ $t('auth.login') }}
                  </div>
                </button>
              </div>

              <!-- <div class="nav-link px-1 pl-3 mx-0 d-flex justify-content-between">
              <a href="#" @click="showTopImage()" style="position: relative">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/luckywin/icons/notification%20(1).png" style="width: 25px;">
              </a>
            </div>

            <van-popup v-model="showTop" round position="top" :style="{ height: '40%' }">
              <h3 class="pl-3 py-3">Latest Messages</h3>
                <div v-for="(list, index) in messages" :key="index" class="mx-4 py-3" style="border-bottom: 1px solid #CFCFCF" v-show="messages.length > 0">
                  <div class="d-flex justify-content-between">
                    <h4>{{ list.title }}</h4><h4>{{ timeFormat(list.created_at) }}</h4>
                  </div>
                  <span class="text-sm">{{ list.message }}</span>
                </div>
                <van-empty description="No Notifications Yet!" v-show="messages.length === 0"/>
            </van-popup> -->

              <!-- <div class="nav-link px-1 mx-0 d-flex justify-content-between">
              <a href="https://t.me/hulk333vip">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/hulk333/icons/telegram%20(1).png" style="width: 25px;">
              </a>
            </div> -->

              <!-- Language -->
              <div
                class="nav-link d-flex justify-content-between px-1 pt-1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div id="navbar-language">
                  <img
                    :src="$t('images.lang-img')"
                    alt=""
                    class="mr-2"
                    style="width: 25px; height: 25px; border-radius: 50%;"
                  />
                </div>
              </div>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbar-language"
              >
                <a
                  class="dropdown-item"
                  @click="setLangLocalstorage('en')"
                ><img
                    src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                    alt=""
                    class="mr-2"
                    style="width: 20px; height: 20px"
                  />
                  {{ $t("en") }}</a>
                <div class="dropdown-divider"></div>
                <a
                  class="dropdown-item"
                  @click="setLangLocalstorage('mm')"
                ><img
                    src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                    alt=""
                    class="mr-2"
                    style="width: 20px; height: 20px"
                  />{{ $t('mm') }}</a>
                <div class="dropdown-divider"></div>
                <a
                  class="dropdown-item"
                  @click="setLangLocalstorage('cn')"
                ><img
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                    alt=""
                    class="mr-2"
                    style="width: 20px; height: 20px"
                  />{{ $t("cn") }}</a>
                <div class="dropdown-divider"></div>
                <a
                  class="dropdown-item"
                  @click="setLangLocalstorage('th')"
                ><img
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                    alt=""
                    class="mr-2"
                    style="width: 20px; height: 20px"
                  />{{ $t("th") }}</a>
              </div>
              <!-- <div class="my-auto pr-2" v-if="alreadyGranted && authUser">
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/b067eede-486d-4336-e303-968134d62f00/public" style="width: auto; height: 35px;" alt="" @click=" askNotificationPermission()">
                  </div> -->
            </div>
          </div>
        </div>
      </nav>
    </Sticky>
  </div>
</template>
<script>
import { Toast, Dialog, Sticky, Loading } from 'vant';
import { mapActions } from 'vuex';
import { isPlaySubdomain as checkPlaySubdomain } from '@/libs/isPlaySubdomain';

export default {
  components: { Sticky, Loading },
  data() {
    return {
      messages: [],
      showTop: false,
      // imageLink: `https://ui-avatars.com/api/?name=${this.$store.state.authUser.email}&background=0D8ABC&color=fff`,
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
      isQuickLogin: false,
    };
  },
  computed: {
    /** e.g. play.spin888.biz — not apex spin888.biz */
    isPlaySubdomain() {
      return checkPlaySubdomain();
    },
    showQuickLogin() {
      return this.isPlaySubdomain;
    },
    isInAppWebView() {
      return this.$store.state.isInAppWebView;
    },
    isAndroid() {
      if (typeof navigator === 'undefined') return false;
      return /android/i.test(navigator.userAgent);
    },
  },
  methods: {
    appInstall() {
      const userAgent = navigator.userAgent;

      console.log(userAgent);

      if (/android/i.test(userAgent)) {
        const apkUrl = this.isPlaySubdomain
          ? 'https://storage.googleapis.com/spacetech2/kob/KOB88-Play.apk?ignoreCache=1'
          : 'https://storage.googleapis.com/spacetech2/kob/KOB88.apk?ignoreCache=1';
        window.location.href = apkUrl;
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // window.location.href = 'https://storage.googleapis.com/spacetech2/phoenix888/phoenix888.mobileconfig?ignoreCache=1';
      } else {
        // Optional: Show a message or fallback
        alert('Unsupported device.');
      }
    },
    timeFormat(time) {
      return moment(time).startOf('hour').fromNow();
    },
    async getMessages() {
      try {
        const res = await axios.get('/messages');
        this.messages = res.data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    showTopImage() {
      this.showTop = !this.showTop;
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    askNotificationPermission() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === 'granted') {
          this.alreadyGranted = false;
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission granted!'
              : 'အသိပေးချက်အတည်ပြုပြီးပြီ'
          );
        } else {
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission denied!'
              : 'အသိပေးချက်အတည်ပြုမပြီးပြီ'
          );
        }
      });
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
            this.$router.go();
          } else {
            this.$router.push('/home');
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    closeNavCollapse() {
      $('#navbar-default').collapse('hide');
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language
      $('#navbar-default').collapse('hide');
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => { });
      $('#navbar-default').collapse('hide');
    },
    redirectRoute(path) {
      if (path === '2d') {
        this.$router.push('/user/2d');
      } else {
        this.$router.push('/user/3d');
      }
      return true;
    },
    async quickLogin() {
      if (!checkPlaySubdomain()) {
        return;
      }
      this.isQuickLogin = true;
      try {
        const deviceUuid = localStorage.getItem('device_uuid');
        const res = await this.axios.post('/auth/login-with-device', {
          device_uuid: deviceUuid,
          referralCode: localStorage.getItem('referralCode'),
        });
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        await this.fetchUser();
        this.authUser = this.$store.state.authUser;

        if (res.data.is_first_time === 1) {
          const platform =
            this.$route.query.ref ||
            this.$route.query.referrer ||
            localStorage.getItem('user_platform_ref');
          if (platform) {
            try {
              await this.axios.post('/auth/update-user-platform', {
                user_platform: platform.toLowerCase(),
              });
            } catch (err) {
              console.error('Failed to update platform via query router param:', err);
            }
          }
        }

        this.$router.push('/home');
        Toast.success('Success!');
      } catch (err) {
        console.log("Quick login failed:", err, err.response);
        Toast.fail(this.$t('auth.fail_message'));
      }
      this.isQuickLogin = false;
    },
  },
  async mounted() {
    // this.getMessages();
    // if(window.Notification.permission === 'granted') {
    //   this.alreadyGranted = false;
    // }

    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  }
};
</script>
<style scoped>
/* CSS */
.login-btn {
  background: transparent;
  border: 1px solid #b45309;
  border-radius: 3px;
  padding: .3rem 1.5rem;
  color: #b45309;
}

.coin {
  height: 1.3rem;
  margin-top: -0.25rem;
  margin-right: 0.4rem;
  animation: flip-coin-49989627 2.5s linear infinite;
  animation-delay: 0s;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  transform-style: preserve-3d;
  /* Keeps the 3D effect */
}

/* Define the keyframes for the 3D flip animation */
@keyframes flip-coin-49989627 {
  0% {
    transform: rotateY(0deg);
    /* Front face */
  }

  50% {
    transform: rotateY(180deg);
    /* Back face */
  }

  100% {
    transform: rotateY(360deg);
    /* Front face again */
  }
}

/* Single-row navbar: no wrap on small screens; actions scroll if needed */
.navbar-bar-outer {
  overflow: hidden;
  max-width: 100%;
}

.navbar-bar-row {
  flex-wrap: nowrap !important;
  min-width: 0;
}

.navbar-bar-actions {
  flex-wrap: nowrap !important;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.navbar-bar-actions::-webkit-scrollbar {
  display: none;
}

.navbar {
  padding: 3px;
  padding-left: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  /* border-bottom: 2px solid black; */
}

.navbar-horizontal .navbar-brand img {
  height: 40px;
}

.nav-link {
  cursor: pointer;
}

.navbar-brand.brand-text {
  font-size: 20px;
  color: #ca8a04;
  margin-left: 0px;
  margin-right: 10px;
}

.navbar-brand {
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.dropdown-item {
  cursor: pointer;
}

.bg-default {
  background-color: #422006 !important;
}

@media (max-width: 767.98px) {
  .navbar-brand {
    font-size: 14px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .navbar-horizontal .navbar-brand img {
    height: 32px;
  }

  .navbar-bar-actions .btn.my-4 {
    margin-top: 0.35rem !important;
    margin-bottom: 0.35rem !important;
    padding-top: 0.3rem !important;
    padding-bottom: 0.3rem !important;
    font-size: 0.72rem;
  }
}
</style>
